import { render, staticRenderFns } from "./RptAllMchTraDet.vue?vue&type=template&id=63062b8c"
import script from "./RptAllMchTraDet.vue?vue&type=script&lang=js"
export * from "./RptAllMchTraDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports